import { render, staticRenderFns } from "./jgbkd.vue?vue&type=template&id=a9b4d8ae&scoped=true"
import script from "./jgbkd.vue?vue&type=script&lang=js"
export * from "./jgbkd.vue?vue&type=script&lang=js"
import style0 from "./jgbkd.vue?vue&type=style&index=0&id=a9b4d8ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b4d8ae",
  null
  
)

export default component.exports